import { useState } from "react";
import useScrollReveal from "../hooks/useScrollReveal";

const EMAIL = "mosti.dev@gmail.com";
const GITHUB = "https://github.com/juanpablohdzm";
const LINKEDIN = "https://www.linkedin.com/in/juan-pablo-h-b64094147/";

export default function Contact() {
    const [copied, setCopied] = useState(false);
    const titleRef = useScrollReveal();
    const bodyRef = useScrollReveal();

    const copyEmail = () => {
        navigator.clipboard.writeText(EMAIL).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <section id="contact" className="py-24 bg-slate-900/50">
            <div className="max-w-6xl mx-auto px-6">
                <div ref={titleRef} className="reveal mb-12 text-center">
                    <p className="font-mono text-xs text-slate-500 mb-2">{"// contact"}</p>
                    <h2 className="text-2xl font-bold text-slate-100">Get in Touch</h2>
                </div>

                <div ref={bodyRef} className="reveal max-w-lg mx-auto text-center">
                    <p className="text-slate-400 text-sm mb-8">
                        I'm open to senior / staff-level roles in real-time, engine, and backend systems.
                        The best way to reach me is by email.
                    </p>

                    {/* Email */}
                    <div className="flex items-center justify-center gap-3 mb-4">
                        <span className="font-mono text-slate-200 text-sm">{EMAIL}</span>
                        <button
                            onClick={copyEmail}
                            className={`font-mono text-xs px-3 py-1.5 rounded border transition-all ${
                                copied
                                    ? "border-emerald-400/50 text-emerald-400 bg-emerald-400/10"
                                    : "border-slate-700 text-slate-400 hover:border-sky-400/50 hover:text-sky-400"
                            }`}
                        >
                            {copied ? "✓ Copied!" : "Copy"}
                        </button>
                    </div>

                    {/* Social links */}
                    <div className="flex items-center justify-center gap-4 mb-8">
                        <a
                            href={GITHUB}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 font-mono text-xs text-slate-400 hover:text-sky-400 transition-colors"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" />
                            </svg>
                            GitHub
                        </a>
                        <span className="text-slate-700">·</span>
                        <a
                            href={LINKEDIN}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 font-mono text-xs text-slate-400 hover:text-sky-400 transition-colors"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                            </svg>
                            LinkedIn
                        </a>
                    </div>

                    {/* No form note */}
                    <p className="font-mono text-xs text-slate-600">
                        No form. No data stored.
                    </p>
                </div>
            </div>
        </section>
    );
}
